<template>
    <date-range-picker
        :start-date="dateRange.start"
        :end-date="dateRange.end"
        v-on:update="updateDate"
        dusk="looker-date-range-picker"
    ></date-range-picker>
</template>

<script>

export default {
    props: ['value'],

    data() {
        return {
            dateRange: {
                // "7 days ago" is the default for looker, but for some reason we have to subtract 6.
                start: moment().subtract(6, 'd'),
                end: moment()
            }
        }
    },

    created() {
        this.emitDateRange();
    },

    methods: {
        updateDate(dateStart, dateEnd, frequency) {
            this.dateRange = {
                start: moment(dateStart),
                end: moment(dateEnd)
            };

            this.emitDateRange();
        },

        emitDateRange() {
            this.$emit('input', this.dateRange);
        }
    }
}
</script>
